import { Injectable, OnDestroy } from '@angular/core';
import { copy } from '@mydocma/common/src/lib/deep';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { Task, TaskFileDownloadService, TaskService, TaskStatusEnum } from '@mydocma/task';
import { BehaviorSubject } from 'rxjs';
import { MmFaultsReportingService } from '../../../mm-faults-reporting.service';
import { WritingEmailParameter } from '../../common/writing-email-parameter';
import { WritingExternalRecipient } from '../../common/writing-external-recipient';
import { FaultWritingReportConfig } from '../../faults-writing-report.config';
import { MmFaultsWritingReportingService } from '../../mm-fault-writing-reporting.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Logger } from '@mydocma/common/src/lib/logger';

@UntilDestroy()
@Injectable()
export class WritingPreviewService implements OnDestroy {


  private recipient: WritingExternalRecipient;
  private currentTask: Task;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(private readonly reportingService: MmFaultsWritingReportingService,
              private readonly taskDownloadService: TaskFileDownloadService,
              private readonly mmReportingService: MmFaultsReportingService,
              private readonly notificationService: NotificationService,
              private readonly logger: Logger) {


    mmReportingService.onReportTaskFinished
      .pipe(untilDestroyed(this))
      .subscribe(async task => {
        if (this.currentTask) {
          if (task.id === this.currentTask.id) {
            await this.onTaskChanged(task);
          }
        }
      });

    mmReportingService.onReportFileDownloaded
      .pipe(untilDestroyed(this))
      .subscribe(async res => {
        if (this.currentTask && this.recipient) {
          if (res.task?.id === this.currentTask.id) {
            this.recipient.PreviewFile = res.file;
          }
        }
      });

  }
  ngOnDestroy(): void {
  }


  private async onTaskChanged(task: Task) {
    this.currentTask = task;
    const status = task.status.value;
    if (status === TaskStatusEnum.ended) {
      this.reportingService.emailButtonDisabled = false;
      this.reset();
    } else if (status === TaskStatusEnum.failed || status === TaskStatusEnum.canceled) {
      this.reportingService.emailButtonDisabled = false;
      this.reset();
      this.logger.error('An error while creating writing preview', '', 'WritingPreviewService');
      this.notificationService.error('An error while creating writing preview');
    }
  }

  async openPreview(recipient: WritingExternalRecipient, reportConfig: FaultWritingReportConfig) {
    try {
      if (this.loadingSubject.value) {
        return;
      }
      this.recipient = recipient;
      if (this.recipient.PreviewFile) {
         await this.taskDownloadService.downloadFile(this.recipient.PreviewFile, {open: true, preventBrowserDownload: true});
         return;
      }
      this.loadingSubject.next(true);
      this.currentTask = await this.reportingService.previewWriting(recipient.ExternalReportId, reportConfig);

    } catch (ex) {
      this.loadingSubject.next(false);
      this.logger.error(ex, '', 'WritingPreviewService');
      this.notificationService.error('An error while creating writing preview');
    }
  }

  async openEmailBodyPreview(reportConfig: FaultWritingReportConfig, emailParameter: WritingEmailParameter) {
    try {
      if (this.loadingSubject.value) {
        return;
      }
      const clone = copy(reportConfig);
      this.loadingSubject.next(true);
      this.currentTask = await this.reportingService.previewWritingEmailBody(clone, emailParameter);

    } catch (ex) {
      this.reportingService.emailButtonDisabled = false;
      this.loadingSubject.next(false);
      this.logger.error(ex, '', 'WritingPreviewService');
      this.notificationService.error('An error while creating writing email preview');
    }
  }

  private reset() {
    this.loadingSubject.next(false);
    this.currentTask = null;

  }




}
